import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconWebsite: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="website, webbuilder, coding"><path d="M20.25 3.75H3.75V20.25H20.25V3.75Z" stroke="currentColor" strokeWidth="1.5"/><path d="M4 7.25H20" stroke="currentColor" strokeWidth="1.5"/><path d="M10.5 11.25L8 13.75L10.5 16.25" stroke="currentColor" strokeWidth="1.5"/><path d="M13.5 11.25L16 13.75L13.5 16.25" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconWebsite;
